import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useCommonHooks } from "../hooks/useCommonHooks";
import {
  OrcaCommonContext,
  useOrcaCommonContext
} from "./OrcaCommonContext.hooks";

// Hook lives in .hooks so light entries (e.g. video/wrapper) avoid this module's
// useCommonHooks graph. Re-export keeps existing OrcaCommonContext import paths.
export { useOrcaCommonContext };

export const OrcaCommonProvider = ({
  children,
  config = {},
  optionalHandlers = {}
}) => {
  const {
    initDuration,
    initializeNewVideo,
    promoState,
    setPromoState,
    resetVideoState,
    isFullscreen,
    isNativeIOSPlayer,
    setIsFullscreen,
    reset,
    playerState,
    playerSize,
    renderControls,
    setRenderControls,
    playerWrapperRef,
    promoElement,
    fullScreenWrapper,
    onPlayButton,
    play,
    pause,
    toggleMute,
    handleVolumeChange,
    setShowSubtitles,
    handlePlayEvent,
    resetControlsState,
    handleLivePreview,
    setInitialMuteState,
    autoplay,
    showFullscreenBtn,
    closeFullscreen,
    closeStickyPlayer
  } = useCommonHooks(config, optionalHandlers);

  const contextValue = useMemo(
    () => ({
      initDuration,
      initializeNewVideo,
      promoState,
      setPromoState,
      resetVideoState,
      isFullscreen,
      isNativeIOSPlayer,
      setIsFullscreen,
      reset,
      playerState,
      playerSize,
      renderControls,
      setRenderControls,
      playerWrapperRef,
      promoElement,
      fullScreenWrapper,
      onPlayButton,
      play,
      pause,
      toggleMute,
      handleVolumeChange,
      setShowSubtitles,
      handlePlayEvent,
      resetControlsState,
      handleLivePreview,
      setInitialMuteState,
      autoplay,
      showFullscreenBtn,
      closeFullscreen,
      closeStickyPlayer
    }),
    [
      initDuration,
      initializeNewVideo,
      promoState,
      setPromoState,
      resetVideoState,
      isFullscreen,
      isNativeIOSPlayer,
      setIsFullscreen,
      reset,
      playerState,
      playerSize,
      renderControls,
      setRenderControls,
      playerWrapperRef,
      promoElement,
      fullScreenWrapper,
      onPlayButton,
      play,
      pause,
      toggleMute,
      handleVolumeChange,
      setShowSubtitles,
      handlePlayEvent,
      resetControlsState,
      handleLivePreview,
      setInitialMuteState,
      autoplay,
      showFullscreenBtn,
      closeFullscreen,
      closeStickyPlayer
    ]
  );

  return (
    <OrcaCommonContext.Provider value={contextValue}>
      {children}
    </OrcaCommonContext.Provider>
  );
};

OrcaCommonProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node,
  optionalHandlers: PropTypes.object
};
